/**
 * 可持久化媒体 URL 清洗
 *
 * 生成任务的 DTO（如 /api/images/:id）返回的 resultUrl 可能携带服务端附上的
 * 短时 mediaToken（默认 30 分钟过期）。节点数据会随画布快照持久化到服务端，
 * 直接写入带 token 的 URL 会导致：快照里积累过期凭据 + 30 分钟后图片 401。
 *
 * 写入节点数据（imageUrl / videoUrl / coverUrl / 素材库收藏）前统一过这一层，
 * 只保留网关路径；展示时 resolveBrowserMediaUrl 会用当前会话的媒体令牌重新附加。
 */

/** 剥离媒体网关 URL 上的 query/hash（mediaToken、download 等均为展示期参数）；非网关 URL 原样返回 */
export function toPersistableMediaUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  const url = String(value).trim();
  if (!url || !url.includes('/api/media/file/')) return url || null;
  const cutIndex = url.search(/[?#]/);
  return cutIndex >= 0 ? url.slice(0, cutIndex) : url;
}
